// Products hidden from the public site (catalog, search, cards, cart, sitemap, feeds, content links).
// Admin, operator panel and marketplace integrations keep seeing them. To bring one back — remove its slug.
// Keep in sync with supabase/functions/_shared/hiddenProducts.ts (edge functions can't import src/).
export const HIDDEN_PRODUCT_SLUGS = ["tirzaplus-10mg", "tirzaplus-30mg", "semaplus-5mg"];

const HIDDEN_SET = new Set(HIDDEN_PRODUCT_SLUGS);

export const isHiddenProductSlug = (slug) => !!slug && HIDDEN_SET.has(String(slug).toLowerCase());

/** Drops hidden products from a list of rows that have a `slug` field. */
export const filterVisibleProducts = (rows) =>
  (rows || []).filter((p) => !isHiddenProductSlug(p?.slug));

const slugAlt = HIDDEN_PRODUCT_SLUGS.map((s) => s.replace(/[-]/g, "\\-")).join("|");
const HREF_RE = new RegExp(`/products/(?:${slugAlt})(?=[/?#"')\\s]|$)`, "i");

/** True when a link points at a hidden product page. */
export const isHiddenProductHref = (href) => !!href && HREF_RE.test(String(href));

const MD_LINK_RE = new RegExp(`\\[([^\\]]*)\\]\\(\\s*[^)\\s]*/products/(?:${slugAlt})(?:[/?#][^)\\s]*)?(?:\\s+"[^"]*")?\\s*\\)`, "gi");
const HTML_LINK_RE = new RegExp(`<a\\b[^>]*href=["'][^"']*/products/(?:${slugAlt})(?:[/?#][^"']*)?["'][^>]*>([\\s\\S]*?)</a>`, "gi");

/** Replaces Markdown/HTML links to hidden products with their plain text (content in DB stays untouched). */
export const stripHiddenProductLinks = (text) => {
  if (!text || typeof text !== "string") return text;
  return text.replace(MD_LINK_RE, "$1").replace(HTML_LINK_RE, "$1");
};
